module.exports = __webpack_public_path__ + "media/images/basic-logos/loading-150-33188bd64dcaecda60ca85c33ebe6160.gif";